"use client";

import { c as _c } from "react/compiler-runtime";
import { setBreadcrumbs } from "@navikt/nav-dekoratoren-moduler";
import { useParams, useSelectedLayoutSegments } from "next/navigation";
import { useLayoutEffect } from "react";
import { createFullUrl, getBaseBreadcrumbsForSM, SM_BREADCRUMB_TITLES } from "@/common/breadcrumbs";
import { SM_SEGMENT } from "@/common/route-hrefs";
export function BreadcrumbsUpdaterForSM() {
  const $ = _c(4);
  const segments = useSelectedLayoutSegments();
  const params = useParams();
  let t0;
  let t1;
  if ($[0] !== params.planId || $[1] !== segments) {
    t0 = () => {
      const baseBreadcrumbs = getBaseBreadcrumbsForSM();
      const [firstSegment] = segments;
      const title = firstSegment ? SM_BREADCRUMB_TITLES[firstSegment] : null;
      if (title && params.planId) {
        setBreadcrumbs([...baseBreadcrumbs, {
          url: createFullUrl(`/${SM_SEGMENT}/${firstSegment}/${params.planId}`),
          title
        }]);
      } else {
        setBreadcrumbs(baseBreadcrumbs);
      }
    };
    t1 = [segments, params.planId];
    $[0] = params.planId;
    $[1] = segments;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useLayoutEffect(t0, t1);
  return null;
}